import { Badge } from "reactstrap";
import Ranga from "../enums/Ranga";
import LinkType from "../enums/LinkType";

const ImprezaSimple = ({ino}) => {

  const renderLinks = () => {
    return (
      <div className="ino-simple-container mt-10">
        {ino.Links.map((link) => {
          if (!link.LinkType || link.LinkType == 1) return null;
          const linkType = LinkType[link.LinkType];
          return <a href={link.Url} target="_blank" rel="noopener noreferrer" className="ino-link"><i className={`fa ${linkType.icon} fa-2x`} title={linkType.description}></i></a>
        })}
      </div>
    );
  };

  const renderRangi = () => {
    return (
      <div className="ino-simple-container">
        {ino.Rangi.map((ranga) => <Badge className="ranga">{Ranga[ranga].value}</Badge>)}
      </div>
    );
  };

  return (
    <>
      <div className={`ino-container${Number(ino.WasCancelled) === 1 ? " ino-container--cancelled" : ""}`}>
        <div className="ino-logo">
          <img src={ino.Logo}/>
        </div>
        <div className="ino-content">
          <h4>{ino.Nazwa}</h4>
          <p>
            <i className="fa fa-calendar"></i> {ino.TerminOd} {ino.TerminDo && `do ${ino.TerminDo}`}
          </p>
          <p>
            <i className="fa fa-map-marker"></i> {ino.Miejsce} {ino.Wojewodztwo && `woj. ${ino.Wojewodztwo}`}
          </p>
          {ino.Komentarz && (
            <p className="comment">
              {ino.Komentarz}
            </p>
          )}
          {ino.Links && ino.Links.length > 0 && renderLinks()}
          {ino.Rangi && ino.Rangi.length > 0 && renderRangi()}
        </div>
      </div>
    </>
  )
}

export default ImprezaSimple
